/* eslint-disable react/prop-types */
import { Trans, useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

function TotalRowsStatusBar(props) {
  const { api } = props;

  const { t } = useTranslation(['icp-components']);

  const [, setRefreshFlag] = useState(Date.now());

  const total = api.paginationGetRowCount() || api.getDisplayedRowCount();
  const selectedCount = api.getSelectedRows().length;

  useEffect(() => {
    const updateStatusBar = () => {
      setRefreshFlag(Date.now());
    };

    api.addEventListener('paginationChanged', updateStatusBar);
    api.addEventListener('selectionChanged', updateStatusBar);

    return () => {
      if (!api.isDestroyed()) {
        api.removeEventListener('paginationChanged', updateStatusBar);
        api.removeEventListener('selectionChanged', updateStatusBar);
      }
    };
  }, [api]);

  return (
    <span className="icp-table-total-rows icp-center">
      <Trans i18nKey="table.total" t={t} values={{ total }} components={[<b />]} />
      {selectedCount > 0 && (
        <>
          {' '}
          <Trans
            i18nKey="table.selected"
            t={t}
            values={{ count: selectedCount }}
            components={[<b />]}
          />
        </>
      )}
    </span>
  );
}

export default TotalRowsStatusBar;
